import { VIEWS_CHART_COUNT } from "../../../../utils/constants";
import * as Types from "../../../actions/actionTypes";

const initialState = {};

for (
  let i = VIEWS_CHART_COUNT.ads.chart.start;
  i < VIEWS_CHART_COUNT.ads.chart.end;
  i++
) {
  initialState["adsChart" + i] = {
    loading: true,
    data: {
      chart_label: "",
      data: [],
      legends: [],
      chart_info: {
        chart_label: "",
        data: {},
      },
    },
    error: "",
  };
}

function adsChartReducer(state = initialState, action) {
  const newState = { ...state };

  for (
    let i = VIEWS_CHART_COUNT.ads.chart.start;
    i < VIEWS_CHART_COUNT.ads.chart.end;
    i++
  ) {
    const chartNumber = "adsChart" + i;

    if (
      action.type === Types.adsChartActionTypes[`ADS_CHART_${i}_DATA_LOADING`]
    ) {
      newState[chartNumber] = {
        ...state[chartNumber],
        loading: action.payload,
      };
      return newState;
    }
    if (
      action.type === Types.adsChartActionTypes[`ADS_CHART_${i}_DATA_LOADED`]
    ) {
      newState[chartNumber] = {
        ...state[chartNumber],
        data: action.payload,
        error: "",
      };
      return newState;
    }
    if (
      action.type ===
      Types.adsChartActionTypes[`ADS_CHART_${i}_DATA_LOAD_ERROR`]
    ) {
      newState[chartNumber] = {
        ...state[chartNumber],
        error: action.payload,
      };
      return newState;
    }
  }

  if (action.type === Types.RESET_ADS_CHART_DATA) {
    return initialState;
  }

  return state;
}

export default adsChartReducer;
